import { render } from "./ProjectPublicationHistoryListItemQuiz.vue?vue&type=template&id=23c878d6&scoped=true"
import script from "./ProjectPublicationHistoryListItemQuiz.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemQuiz.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemQuiz.vue?vue&type=style&index=0&id=23c878d6&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c878d6"]])

export default __exports__